import { classNames } from "primereact/utils";

type Props = {
	height?: string;
	width?: string;
};

const Spacing = ({ height, width }: Props) => {
	return <div className={classNames(height, width)} />;
};

export default Spacing;
